import builder from '../builder';
import CloseQuote from '../../streamline-icons/bold/close-quote.svg';

export default builder('IconCloseQuoteBold', CloseQuote);
